import React, { useEffect, useState } from 'react'

import axios from 'axios'

import { ApiCallPost } from '../../ApiCall/ApiCall'

function AddSecond( {code ,exitadd , naturaleza}) {

    const [value,setValue] = useState( "" )
    const [codigos,setCodigos] = useState( [] )
    const [nameCodigo,setNameCodigo] = useState( "") ;
    const [cero,setCero] = useState( "")
   

    const [nat,setNat] = useState( "A" )

    const [tipo,setTipo] = useState( "R")


    useEffect(() => {
        setNat( naturaleza)
    } ,[naturaleza])



    function handleGuardar()
    {

        var obj = {
            nivel :"2" ,
            parent : code ,
            second : value ,
            name : nameCodigo ,
            naturaleza : nat ,
            tipo : tipo , // Poner un state
            comment : document.getElementById("comentario").value ,
            dTimeStamp : getFormatDate( new Date() )
        }

        console.log( "handleGuardar =  " + JSON.stringify( obj ) ) ;


        ApiCallPost( "savesecond" , obj )
        .then((result) => {
            console.log( "result " + JSON.stringify( result ) ) ;
            return ;
        })
        .catch((err) => {
            console.log( err ) ;
        })


    }

    function getFormatDate(d) {
        var date = new Date(d);
        var dateStr =
            date.getFullYear() + "-" +
            ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("00" + date.getDate()).slice(-2) + " " +
            ("00" + date.getHours()).slice(-2) + ":" +
            ("00" + date.getMinutes()).slice(-2) + ":" +
            ("00" + date.getSeconds()).slice(-2);
        //console.log(dateStr);
    
        return dateStr;
    }
    

    function handleOnChange( val)
    {
        //console.log( "onChange val = " + JSON.stringify( val ) )

        var value = document.getElementById( "codigos").value ;

        console.log( "Value = " + value ) ;

        setValue( value ) ;

        for( var i = 0 ; i< codigos.length ; i++ )
        {
             if (  codigos[i].codigo === value )
             {

                setNameCodigo( codigos[i].nombre ) ;

                return  ; 

             }
        }


    }



    useEffect(() => {

    axios.get('http://localhost:3004/livefactura/getCodigoAgrupadorSecond/?code=' + code)
    .then((result) => {

        console.log( "Codigo = " + JSON.stringify( result) ) ;

        fillSelect( result.data ) ;

        setCodigos( result.data )

        setCero( result.data[0].nombre )

        console.log( "******"  + codigos.length )

        //setTimeout( () => { console.log( codigos.length ) }, 2000) // setNameCodigo( codigos[0].nombre ) 

        handleOnChange( result.data[0].codigo)
        
    }).catch((err) => {

        console.log( err ) ;
        
    });

        


    }, [])


    useEffect(() =>{

        console.log( "useEffect")

        if( cero===undefined)
        {return ;}

        console.log( "cero = " + cero ) ;

        setNameCodigo( cero ) ;


    } ,[cero])


    function fillSelect(response)
    {
        var select = document.getElementById('codigos') ;

        while( select.length > 0 )
        {
            select.remove( select.length -1 ) ;
        }
    
        for( var i = 0 ; i < response.length ; i++)
        {
           
    
            var option = document.createElement("option");
            option.value = response[i].codigo;
            option.text =  response[i].codigo  ;

            select.appendChild(option)
    
        }

    }
    

  return (
    

<div className='box-login float-end' style={{ top:'25%' , 
        right:'35%' , backgroundColor :'lightgray' , borderRadius:'20px' ,  
        position : 'fixed' , zIndex : 200}} >

    <div className='d-flex flex-column align-items-center' 
        style={{borderWidth:2 , borderColor :'black' , fontFamily : 'Satoshi-Bold'}}>

        <div>
            <p className='tx-color-purple body-1 mt-2'>Codigo Segundo Nivel</p>
        </div>

        <div className='display-label-none  w-100'>                    

            <form id='myForm form-2'  style={{color:'black'}}>
        
                <div className="form-outline m-4 mt-1 mb-1 " >
                    <label className="form-label" htmlFor="codigo" >Codigo</label>
                    <input readOnly type="text" id="codigo" value={code}
                    className="form-control" placeholder="Codigo" />
                    
                </div>


                <div className="form-group m-4 mt-1 mb-1">
                    <label for="codigos">Seleccione Código</label>
                    <select className="form-control" id="codigos" onChange={handleOnChange}>
                    <option>USD 100K - 125K</option>
                    
                    </select>
                </div>


                <div className="form-outline m-4 mt-1 mb-1 " >
                    <label className="form-label" htmlFor="codigo2" >Segundo Nivel</label>
                    <input value={value} readOnly type="text" id="codigo2" className="form-control" placeholder="Codigo2" />
                    
                </div>

                <div className="form-outline m-4 mt-1 mb-1 " >
                    <label className="form-label" htmlFor="nombre" >Nombre</label>
                    <input readOnly type="text" value={nameCodigo}
                    id="nombre" className="form-control" placeholder="Nombre" />
                    
                </div>


                <div className="form-outline m-4 mt-1 mb-1 " >
                    <label className="form-label" htmlFor="comentario" >Comentario</label>
                    <textarea  type="textarea" 
                    id="comentario" className="form-control" placeholder="Comentario" />
                    
                </div>



                {
                    ( naturaleza === "A" || naturaleza === "D" )&& (

                        <div className='m-4 mt-2 mb-1'>
                            <div className='row' >
                                <div className='col-4'>
                                    <p>Naturaleza</p>
                                </div>
                                <div className='col-4'>
                                    <p>{(naturaleza === "A" ? "Acredor" : "Deudor")}</p>
                                </div>
                            </div>
                        </div>
                    )
                }

                {
                    naturaleza === "AD" && (

                        <div className='m-4 mt-1 mb-1'>

                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name='nat' 
                                    id="inlineCheckbox1" onChange={() => setNat('A')}
                                     value="option1" checked={(nat==='A')}/>
                                <label className="form-check-label" for="inlineCheckbox1">Acreedora</label>
                            </div>

                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name='nat' 
                                    id="inlineCheckbox2"  onChange={() => setNat('D')}
                                    value="option2" checked={(nat==='D')}/>
                                <label className="form-check-label" for="inlineCheckbox2">Deudora</label>
                            </div>

                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name='nat' 
                                    id="inlineCheckbox2"  onChange={() => setNat('AD')}
                                    value="option2" checked={(nat==='AD')}/>
                                <label className="form-check-label" for="inlineCheckbox2">AD</label>
                            </div>

                        
                        </div>
                    )

                }


                <div className='m-4 mt-1 mb-1'>

                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name='tip' 
                            id="tipor" onChange={() => setTipo('R')}
                            value="option1" checked={tipo==='R'}/>
                        <label className="form-check-label" for="tipor">Resumen</label>
                    </div>

                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name='tip' 
                            id="tipod" onChange={() => setTipo('D')}
                            value="option2" checked={tipo==='D'}/>
                        <label className="form-check-label" for="tipod">Detalle</label>
                    </div>



                </div>






                <div className='row'>


                    <div className='col-5'>
                        <button type="button" onClick={handleGuardar} className="button-2 m-4">Guardar</button>
                    </div>
                    <div className='col-1'>

                    </div>
                    

                    <div className='col-4'>
                        <button type="button" onClick={exitadd} className="button-2 m-4">Salir</button>
                    </div>

                    <div className='col-2'>

                    </div>
                    
                </div>
            </form>
        </div>
    </div>
</div>

  )
}

export default AddSecond